module.exports = __webpack_public_path__ + "static/media/logo.5743b42c.png";